import React from 'react'
import redouteTheme from '../../../src/packages/Theme/lib/theme.js' // @TODO : find a way to have a root path here ('docs/redoute-theme')
import { ThemeProvider } from 'emotion-theming'

export default (props) => <ThemeProvider theme={redouteTheme} {...props} />
